import { Box, Button, CircularProgress, TextField } from "@mui/material";
import Modal from "@mui/material/Modal";
import { useEffect, useState } from 'react'
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import './index.scss'
import { useUpdateNoteMutation } from "../../../../../graphql/generated/graphql";
import { useUserInfoState } from "../../../../hooks/userInfo";
import { setAlertDescription } from "../../../../hooks/actions";
import { Note } from "@mui/icons-material";

const modules = {
  toolbar: {
    container: '#toolbarmodal',
  }
}

const CustomToolbar = () => (
  <div id="toolbarmodal">
    <button className="ql-underline" />
    <button className="ql-bold" />
    <button className="ql-italic" />
    <button className="ql-strike" />
    <button className="ql-list" value='check' />
    <button className="ql-list" value='ordered' />
    <button className="ql-list" value='bullet' />
  </div>
);

const style = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "20px",
  backgroundColor: 'white',
  width: '450px',
  height: '600px'
};

interface ModalNoteProps {
  open: boolean,
  handleModal: (open: boolean) => void,
  title: string,
  content: string,
  idNote: number,
  refetch: any,
}

const ModalEditNote = (props: ModalNoteProps) => {

  const { open, handleModal, title, content, idNote, refetch } = props
  const [titleEdit, setTitleEdit] = useState(title);
  const [isLoading, setIsLoading] = useState(false)
  const [contentEdit, setContentEdit] = useState(content);
  const [updateNote] = useUpdateNoteMutation()
  const userInfoState = useUserInfoState();

  useEffect(() => {
    if (title) {
      setTitleEdit(title);
    } else if (title === '') {
      setTitleEdit('')
    }
  }, [title, open]);

  useEffect(() => {
    if (content) {
      setContentEdit(content);
    }
  }, [content, open]);

  const saveNote = async () => {
    setIsLoading(true)
    try {
      await updateNote({
        variables: {
          note_id: idNote,
          title: titleEdit,
          content: contentEdit
        },
      }).then((res) => {
        setIsLoading(false);
        setAlertDescription({
          open: true,
          message: 'The Note has been delete succesfully',
          severity: 'success',
        })
        if (refetch) {
          refetch();
        }
        handleModal(false);
      })
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <Modal
      open={open}
      onClose={() => {
        handleModal(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            flexDirection: "column",
            paddingY: '16px',
            paddingX: '20px'
          }}
        >
          <TextField
            fullWidth
            InputProps={{
              className: 'input-text-title',
              disableUnderline: true,
            }}
            placeholder="Add title..."
            variant="standard"
            value={titleEdit}
            onChange={(e) => setTitleEdit(e.target.value)}
          />
          <hr />
          <ReactQuill
            theme="snow"
            value={contentEdit}
            onChange={setContentEdit}
            modules={modules}
            style={{
              width: '100%',
              height: '480px'
            }}
            placeholder="write ..."
          />
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%'
            }}
          >
            <CustomToolbar />
            <Button
              sx={{
                width: '20%',
                marginRight: 1,
                height: '32px'
              }}
              variant="contained"
              onClick={saveNote}
            >
              {isLoading ?
                <CircularProgress
                  color="secondary"
                  size={20}
                /> : 'Save'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default ModalEditNote